import { render, staticRenderFns } from "./NavUserInfo.vue?vue&type=template&id=535d20ec&"
import script from "./NavUserInfo.vue?vue&type=script&lang=js&"
export * from "./NavUserInfo.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports